/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import { useSnackbar } from 'notistack';
import { Redirect, useParams } from 'react-router-dom';
import DBModuleHeaderLayout from 'components/Common/Layouts/DBModuleHeaderLayout';
import CircularProgress from '@mui/material/CircularProgress';

// --- CHANGED: Imported TariffPage instead of TariffDetail ---
// Ensure this path matches where you saved the TariffPage.tsx file
import TariffPage from 'pages/tariffs/TariffPage';
import { useGetTariffById } from 'api/bitedb/tariffs/tariffs.hooks';
import { getDatabaseById } from 'api/bitedb/database/database.service';

const Tariff: React.FC = (props: any) => {
  const { id } = useParams<{ id: string }>();
  const { cur_user } = useContext(GlobalContext);
  const { enqueueSnackbar } = useSnackbar();
  const selectedTeamId = cur_user?.selected_team?.id;
  const [viewType, setViewType] = useState<string>('');
  const [userHasMonitor, setUserHasMonitor] = useState(true);
  const [isCheckingSubscription, setIsCheckingSubscription] = useState(true);
  const [isRouteBlocked, setIsRouteBlocked] = useState(false);
  // We fetch here to handle the loading state for the layout wrapper
  const {
    data: transaction,
    error: transactionError,
    isLoading: transactionLoading,
  } = useGetTariffById(id, userHasMonitor); // Pass userHasMonitor to control when the query runs

  useEffect(() => {
    if (transactionError) {
      enqueueSnackbar(
        `Error fetching tariff transaction: ${transactionError}`,
        {
          variant: 'error',
        },
      );
    }
  }, [transactionError, enqueueSnackbar]);

  const requiredTiers = [
    'pro',
    'business',
    'enterprise',
    'database',
    'tariff database',
  ];

  const checkSubscription = async () => {
    if (cur_user.quickcodeOnly) {
      setUserHasMonitor(true);
      setIsCheckingSubscription(false);
      return;
    }
    try {
      if (
        !requiredTiers.includes(cur_user.license) ||
        !requiredTiers.some((role) =>
          cur_user.selected_team?.attributes?.tier.includes(role),
        )
      ) {
        setUserHasMonitor(false);
        setIsCheckingSubscription(false);
        return;
      }
    } finally {
      setIsCheckingSubscription(false);
    }
  };

  useEffect(() => {
    if (cur_user.selected_team) {
      checkSubscription();
    }
  }, [cur_user.selected_team]);

  useEffect(() => {
    const verifyDatabaseOwnership = async () => {
      if (!userHasMonitor || !transaction?.database_id || !selectedTeamId) {
        return;
      }
      const database = await getDatabaseById(transaction.database_id);
      setIsRouteBlocked(
        !!database?.group_id && database.group_id !== selectedTeamId,
      );
    };

    verifyDatabaseOwnership();
  }, [
    transaction?.database_id,
    selectedTeamId,
    userHasMonitor,
  ]);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const helpContent: React.ReactNode = (
    <p className='module-header-tooltip-text'>
      Upload, calculate and store duty and tariffs data related to your
      products.
    </p>
  );

  useEffect(() => {
    if (props.location.state) {
      const { objectData } = props.location.state;
      if (objectData && objectData.viewType) {
        setViewType(objectData.viewType);
      }
    }
  }, [transaction, props.location.state]);

  // Reached from two different flows: the Tariff Analyzer run list
  // (TariffRunDetailsPage, viewType 'Analyzer') or BITE DB's Tariff table
  // (TariffRow, viewType 'Tariff View') — DBModuleHeaderLayout already picks
  // the right link for the middle breadcrumb crumb based on this same
  // viewType; the hub crumb needs to match it instead of always saying
  // "BITE DB".
  const isAnalyzerView = viewType === 'Analyzer';

  return (
    <DBModuleHeaderLayout
      title={transaction?.database_name || 'Loading DB...'}
      helpContent={helpContent}
      htsCode={transaction?.hts_code || 'Loading DB...'}
      databaseId={transaction?.database_id}
      hubLabel={isAnalyzerView ? 'Tariff Analyzer' : 'BITE DB'}
      hubTo={isAnalyzerView ? '/tariff-analyzers' : '/bite-db/entities'}
      // The top ToolBreadcrumb above already shows
      // "Tariff Analyzer/BITE DB > Tariff > <HTS code>", so the secondary
      // title/HTS-badge row and the Help button below it are redundant.
      hideSecondaryTitleRow
      hideHelpButton
      // Match the ~32px header-to-breadcrumb spacing used by the Analyzer
      // detail pages (AceRunDetailsPage, TariffRunDetailsPage,
      // AesRunDetailsPage's '.analyzers-dashboard-root'), since this page
      // is reached from the same Tariff Analyzer flow.
      headerStyle={{ marginTop: 32 }}
    >
      {isRouteBlocked ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <div className='hit-title'>
            You do not have access to this database for the Entity Hub. Switch to the correct team to view it.
          </div>
        </div>
      ) : transactionLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CircularProgress color='primary' />
        </div>
      ) : transaction ? (
        <div>
          <TariffPage />
        </div>
      ) : (
        <></>
      )}
    </DBModuleHeaderLayout>
  );
};

export default Tariff;
